import {Text, View} from "@react-pdf/renderer";
import React, {useContext} from "react";

import { baseStyles } from "../../styles";
import {PDFContext} from "../../BasePDF";

export const PurchaseCustomerPaymentInformationPDF = ( { deal } ) => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null;

    return (
        <View style={{...baseStyles.marginRight, ...baseStyles.table}}>
            <View style={{...baseStyles.tableHeader, backgroundColor: pdfData.pageColor}}>
                <Text>Payment Information</Text>
            </View>

            <View>
                <View style={baseStyles.flexBetween}>
                    <Text>Cash Due on Delivery</Text>
                    <Text>{pdfData.cash_due_on_delivery.toDollarFormat()}</Text>
                </View>

                <View style={baseStyles.flexBetween}>
                    <Text>Payment</Text>
                    <Text>{pdfData.monthly_payment.toDollarFormat()}</Text>
                </View>

                <View style={{...baseStyles.flexBetween}}>
                    <Text>Annual Percentage Rate (APR)</Text>
                    <Text>{pdfData.apr}%</Text>
                </View>

                <View style={{...baseStyles.flexBetween}}>
                    <Text>Term:</Text>
                    <Text>{pdfData.term}</Text>
                </View>
            </View>
        </View>
    )
}